import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
    apiCall,
    getBranches,
    getCustomers
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Select from "react-select";


class ServiceMotoAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            branches: [],
            customers: [],
            vehicles: [],
            loading: false,
            isLoad: true,
            carImageFile: null,
            brands: [],
            models: [],
            selectedBrand: '',
            selectedModel: '',
            formData: {
                brand: '',
                model: '',
                plate: '',
                name: '',
                surname: '',
                branch_id: '',
                is_motor: true,
            }
        }
    }
    async componentDidMount() {
        try {
            this.getBrands();
            this.setState({
                branches: await getBranches(),
                customers: await getCustomers(),
            }, () => {
                this.setState({ isLoad: false });
            });
        } catch (e) {
            this.setState({ isLoad: false })
            throw e;
        }
    }
    getBrands = async () => {
        const response = await apiCall('business/vehicle/get-moto-brands', 'get', null);
        const brandOptions = response.map(brand => ({
            value: brand.id,
            label: brand.name
        }));
        this.setState({ brands: brandOptions });
    }
    getModels = async (brandID) => {
        const response = await apiCall('business/vehicle/get-moto-models/' + brandID, 'get', null);
        const modelOptions = response.map(brand => ({
            value: brand.id,
            label: brand.name
        }));
        this.setState({ models: modelOptions });
    }
    handleBrandChange = async (selectedOption) => {
        const brand_id = selectedOption.value;
        const option = {
            value: selectedOption.value,
            label: selectedOption.label
        }
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                brand: brand_id,
                model: ""
            },
            selectedBrand: option,
            models: []
        }));

        if (brand_id) {
            try {
                const response = await apiCall(`business/vehicle/get-moto-models/${brand_id}`, 'get', null);

                const modelOptions = response.map(model => ({
                    value: model.id,
                    label: model.name
                }));
                this.setState({ models: modelOptions });
            } catch (error) {
                console.error("Modelleri alırken hata oluştu:", error);
            }
        }
    }
    handleModelChange = async (selectedOption) => {
        const model_id = selectedOption.value;
        const option = {
            value: selectedOption.value,
            label: selectedOption.label
        }
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                model: model_id
            },
            selectedModel: option,
        }));
    }
    handleChange = (e) => {
        const { name, value } = e.target;
        const formData = { ...this.state.formData };
        formData[name] = value;
        this.setState({ formData });
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        const { formData } = this.state;
        this.setState({ loading: true });
        const serviceFormData = new FormData();
        Object.keys(formData).forEach(key => {
            serviceFormData.append(key, formData[key]);
        });

        try {
            const response = await apiCall('business/operation/add-with-ai', 'post', serviceFormData);
            this.setState({ loading: false });
            mainHelper.toastMessage(response.status, response.message)
        } catch (e) {
            this.setState({ loading: false });
            console.log(e.response.data.errors);

        }
    }
    render() {
        const { branches, loading, customers, brands, models, selectedBrand, selectedModel } = this.state;
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
                        <div className="loader"
                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className="m-t-30">
                                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
                            </div>
                            <p>Yükleniyor</p>
                            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
                        </div>
                    </div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Motosiklet Servis Kaydı Ekle"
                            Breadcrumb={[
                                { name: "Servisler-Motosiklet", navigate: "services-moto" },
                                { name: "Motosiklet Servis Kaydı Ekle", navigate: "" },
                            ]}
                        />
                        <form onSubmit={this.handleSubmit} encType='multipart/form-data'>
                            <div className="row clearfix justify-content-center">
                                <div className="col-lg-6">
                                    <div className="card">
                                        <div className="body">
                                            <h6 className="text-center">Temel Bilgiler</h6>
                                            <div className="form-group">
                                                <Select
                                                    className="border-danger"
                                                    value={selectedBrand}
                                                    onChange={this.handleBrandChange}
                                                    options={brands}
                                                    placeholder="Marka Seçin"
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            borderColor: state.isFocused ? 'red' : 'red',
                                                            boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                                            '&:hover': { borderColor: 'red' }
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <Select
                                                    className="border-danger"
                                                    value={selectedModel}
                                                    onChange={this.handleModelChange}
                                                    options={models}
                                                    placeholder="Model Seçin"
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            borderColor: state.isFocused ? 'red' : 'red',
                                                            boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                                            '&:hover': { borderColor: 'red' }
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input name="plate"
                                                    id="plate"
                                                    className="form-control"
                                                    placeholder="Plaka *"
                                                    type="text"
                                                    value={this.state.formData.plate}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <h6 className="text-center mt-2 mb-2">Müşteri ve Şube Bilgileri </h6>
                                            <p className="text-center"><small className="text-danger">Sadece yeni müşteri
                                                için formu doldurun.Müşteri Kayıtlı ise
                                                lütfen müşteri seçiniz.</small></p>
                                            <div className="form-group">
                                                <select name="customer_id" id="customer_id"
                                                    className="form-control"
                                                    onChange={this.handleChange}>
                                                    <option value="">Müşteri Seçiniz</option>
                                                    {customers && customers.map((customer) => (
                                                        <option key={customer.id} value={customer.id}>
                                                            {customer.name + ' ' + customer.surname}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <input name="name"
                                                    id="name"
                                                    className="form-control"
                                                    placeholder="Ad *"
                                                    type="text"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input name="surname"
                                                    id="surname"
                                                    className="form-control"
                                                    placeholder="Soyad *"
                                                    type="text"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <select name="branch_id" id='branch_id'
                                                    className="form-control"
                                                    onChange={this.handleChange}>
                                                    <option value="">Şube Seçiniz *</option>
                                                    {branches && (branches.map(branch => (
                                                        <option key={branch.id}
                                                            value={branch.id}>{branch.name}</option>
                                                    )))}

                                                </select>
                                            </div>

                                            <div className="form-group">
                                                <div className="col-lg-6 mx-auto">
                                                    {loading ? (
                                                        <button className="btn btn-outline-primary btn-block"
                                                            disabled={true}
                                                            style={{ textAlign: "-webkit-center" }}>
                                                            Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                                height={'24px'}
                                                                color="#268bd2"></ReactLoading>
                                                        </button>
                                                    ) : (
                                                        <button className="btn btn-outline-primary btn-block"
                                                            type="submit">
                                                            Kaydet
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
            ;
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withRouter(connect(mapStateToProps, {})(ServiceMotoAdd));
